import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";
import {TAction, TFinanceDate} from "../../../app/enum";

import {HotspotService} from "../../../providers/hotspot-service";

@Component({
    selector: 'page-showsync',
    templateUrl: 'showsync.html',
    providers: [HotspotService]
})

export class ShowsyncPage {

    bridgeOffline: any = false;
    bridgeOfflineTxt: string = '';

    config: any;
    logado: any;
    perfil: any;

    analytic: any;

    showDeskIntervalTO: number = 0;
    bridgeOfflineCountI: number = 0;

    audioAlarme: any;
    audioAlarmeI: number;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;

        this.audioAlarme = new Audio('assets/sounds/alarme.mp3');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showsync', '/showsync');

        this.load(true);

    }

    ionViewDidLoad() {

        document.title = 'Showsync';

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    load(isFirst = true, yesterday: boolean = false) {

        let params = '&Syncsee=' + TFinanceDate.fdDia + '&Syncday=' + '2021-01-12';

        let loading = this.util.loadingDots();
        if (isFirst) loading.present();

        this.logadoService.started(TAction.acView, null, params)
            .finally(() => {
                if (isFirst) loading.dismiss();
            })
            .subscribe(data => {

                this.analytic = data.Analytic;

                setTimeout(() => this.load(false), 10000);

                this.stopCounter();

            }, erro => {

                this.startCounter();

                this.showDeskIntervalTO = setTimeout(() => {

                    this.load(false);

                }, 10000);

            });

    }

    datesheet() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Atual (hoje)', handler: () => this.load(false, false)});
        buttons.push({text: 'Anterior (ontem)', handler: () => this.load(false, true)});
        this.util.sheetOpen(buttons, 'PERÍODO');

    }

    startCounter() {

        if (!this.bridgeOffline) {
            this.bridgeOffline = new Date();
            this.bridgeOffline.setSeconds(this.bridgeOffline.getSeconds() - (this.config.request.totalTimeout / 1000) - ((this.config.request.showDeskInterval / 1000)));
        }

        this.bridgeOfflineCountI = setInterval(() => {

            let date = this.util.dateToStr(this.bridgeOffline, true);
            this.bridgeOfflineTxt = this.util.dateText(date, null, 'first');

        }, 1000);

        this.audioAlarmeI = setInterval(() => {

            this.audioAlarme.currentTime = 0;
            this.audioAlarme.play();

        }, 2000);

    }

    stopCounter() {

        this.bridgeOffline = false;

        this.bridgeOfflineCountI && clearInterval(this.bridgeOfflineCountI);

        if (this.audioAlarmeI) {
            this.audioAlarme.pause();
            clearInterval(this.audioAlarmeI);
        }

    }

    fullScreen() {

        clearTimeout(this.showDeskIntervalTO);

        this.util.fullScreen();
        //setTimeout(() => this.load(), 1000);

    }

    dismiss() {

        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showsync/showsync.ts